import script from "./ProductionTreeview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionTreeview.vue?vue&type=script&setup=true&lang=js"

import "./ProductionTreeview.vue?vue&type=style&index=0&id=3ebc352c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebc352c"]])

export default __exports__